"use client";
import React from "react";
import mixpanel from "mixpanel-browser";
import posthog from "posthog-js";
import { useStoreContext } from "@/lib/store";

export function MixpanelInit() {
  const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN;

  if (!MIXPANEL_TOKEN) {
    console.warn("Mixpanel token is missing! Check your .env file.");
    return;
  }
  // @ts-expect-error ignore
  mixpanel.init(MIXPANEL_TOKEN, { autocapture: true });
  return <></>;
}

export function MixpanelProvider() {
  const { user, business, outlet } = useStoreContext();
  const mixpanelIsConfigured = Boolean(
    process.env.NEXT_PUBLIC_MIXPANEL_TOKEN,
  );
  if (user && user?.id) {
    if (mixpanelIsConfigured) {
      mixpanel.identify(user?.id);
      mixpanel.people.set({
        $name: `${user?.firstName} ${user?.lastName}`,
        $email: `${user?.email?.email}`,
        "First Name": `${user?.firstName}`,
        "Last Name": `${user?.lastName}`,
        "Phone Number": `${user?.phoneNumber?.phone}`,
      });
    }
    posthog.identify(user?.id, {
      name: `${user?.firstName} ${user?.lastName}`,
      email: user?.email?.email,
      firstName: user?.firstName,
      lastName: user?.lastName,
      phoneNumber: user?.phoneNumber?.phone,
      businessId: business?.id,
      businessName: business?.name,
    });
  }
  if (mixpanelIsConfigured && business && business?.id) {
    mixpanel.people.set({
      "Business ID": `${business?.id}`,
      "Business Name": `${business?.name}`,
      "Business Owner ID": `${business?.businessOwnerId}`,
    });
  }
  if (mixpanelIsConfigured && outlet) {
    mixpanel.people.set({
      "Outlet ID": `${outlet}`,
    });
  }
  return <></>;
}
